import state from './moduleGroupsState'
import mutations from './moduleGroupsMutations'
import actions from './moduleGroupsActions'
import getters from './moduleGroupsGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
